export const DOMAIN = {
  TANGERINE_DEV: 'https://tangerine-dev1.oneclicklabs.es/',
  TANGERINE_AI_DEV: 'https://tenant-ai-1.oneclicklabs.es/',
  TANGERINE_QA: 'https://tangerine-qa1.oneclicklabs.es/',
  TANGERINE_LATEST: 'https://tangerine-latest.oneclick.es/',
  SANTILLANA_INTEGRATIONS: 'https://santillana-integrations.oneclicklabs.es/',
  SANTILLANA_DEMO: 'https://santillana-demo.oneclick.es/',
  SANTILLANA_ALFA: 'https://alfa-santillana.oneclick.es/',
  MACMILLAN: 'https://digital.macmillaneducation.es/',
  GOT_IT: 'https://gotitbyme.com/',
  BYME_DIGITAL: 'https://bymedigital.com/',
  BILINGUAL_BYME: 'https://digital.bilingualbyme.com/',
  MASTER: 'https://master-editora.oneclick.es/',
  TINTA_FRESCA: 'https://tinta-fresca.oneclick.es/',
  BRUNO: 'https://editorial-bruno.oneclick.es/',
  SANTILLANA_PILOTO: 'https://unoi-mx.oneclick.es/',
  SANTILLANA_BRASIL: 'https://santillana-demo-brasil.oneclick.es/',
  SANTILLANA_BRASIL_COMPARTILHA: 'https://santillana-compartilha-master.oneclick.es/',
  SANTILLANA_COLOMBIA: 'https://santillana-colombia-demo.oneclick.es/',
  SANTILLANA_COLOMBIA_COMPARTIR: 'http://santillana-compartir-colombia-demo.oneclick.es/',
  SANSY: 'https://digitalsansyediciones.es/',
  EDV_DEV: 'https://edelvivesdigital-dev.oneclicklabs.es/',
  EDV_DEV_AI: 'https://tenant-ai-2.oneclicklabs.es/',
  EDV_QA: 'https://edelvivesdigital-qa.oneclicklabs.es/',
  EDV_PROD: 'https://edelvivesdigitalplus.com/',
};

const BASE_DEV = DOMAIN.SANTILLANA_DEMO;
const TANGERINE_AI_DEV = DOMAIN.TANGERINE_AI_DEV;

const BASE_AGNOSTIC = window.location.origin.includes('localhost')
  ? window.location.origin.includes('3018')
    ? TANGERINE_AI_DEV
    : BASE_DEV
  : window.location.origin + '/';

export const defaultConfig = {
  BASE_URL_: BASE_AGNOSTIC,
  API_URL: BASE_AGNOSTIC + 'api/',
  BASE_STORAGE_URL: BASE_AGNOSTIC + 'files-storage-tools/',
};
